/**
 * UI Constants
 * Centralized constants for UI components and layouts
 */

// Application-wide color palette
export const COLORS = {
  background: "#edeae5", // main
  chakraPanel: "#EFE9E1",
  infoPanel: "#E1DCD1",
  divisionLight: "#FFF0DC",
  divisionDark: "#E8FDFF",
  borderColor: "#4E4C48",
  textColor: "#000000",
  buttonTextColor: "#8C7393",
  buttonBorderColor: "rgba(163, 116, 63, 0.53)"
} as const;

// Button dimensions and styling
export const BUTTON_CONSTANTS = {
  HEIGHT: {
    SMALL: '32px',
    MEDIUM: '40px',
    LARGE: '56px'
  },
  BORDER_RADIUS: {
    SMALL: '8px',
    MEDIUM: '10px',
    LARGE: '14px'
  },
  FONT_SIZE: {
    SMALL: '14px',
    MEDIUM: '16px',
    LARGE: '18px'
  }
} as const;

// Input field constants
export const INPUT_CONSTANTS = {
  HEIGHT: '40px',
  BORDER_RADIUS: 'md',
  COLORS: {
    ERROR: 'red.300',
    FOCUS: 'blue.400',
    BORDER: 'gray.300'
  }
} as const;

// Card and container constants
export const CARD_CONSTANTS = {
  BORDER_RADIUS: '16px',
  TRANSITION_DURATION: '0.3s'
} as const;

// Map and interactive components
export const MAP_CONSTANTS = {
  HEIGHT: '48px',
  BORDER_RADIUS: '12px',
  COLORS: {
    PRIMARY: '#4F46E5',
    SECONDARY: '#6B7280'
  }
} as const;

// Z-index hierarchy
export const Z_INDEX = {
  DROPDOWN: 1000,
  MODAL: 2000,
  TOOLTIP: 3000,
  OVERLAY: 4000
} as const;

// Animation and timing constants
export const ANIMATION_CONSTANTS = {
  DURATIONS: {
    FAST: '0.15s',
    MEDIUM: '0.3s',
    SLOW: '0.5s'
  },
  TIMING_FUNCTIONS: {
    EASE_IN_OUT: 'cubic-bezier(0.4, 0, 0.2, 1)',
    EASE_OUT: 'cubic-bezier(0, 0, 0.2, 1)',
    EASE_IN: 'cubic-bezier(0.4, 0, 1, 1)'
  }
} as const;

// Debounce and throttle constants
export const TIMING_CONSTANTS = {
  DEBOUNCE: {
    SEARCH: 300,
    RESIZE: 150,
    SCROLL: 100
  },
  THROTTLE: {
    SCROLL: 16,
    RESIZE: 16,
    MOUSE_MOVE: 16
  }
} as const;

// Desktop-only application - no mobile/tablet breakpoints needed
export const BREAKPOINTS = {
  DESKTOP: 1440
} as const;

// Consolidated UI constants
export const UI_CONSTANTS = {
  BUTTON_CONSTANTS,
  INPUT_CONSTANTS,
  CARD_CONSTANTS,
  MAP_CONSTANTS,
  Z_INDEX,
  ANIMATION_CONSTANTS,
  TIMING_CONSTANTS,
  BREAKPOINTS
} as const;